import {beDateFormat, insertElemsAt, removeAt} from '@fl/cmsch-fe-library';
import moment, {Moment} from 'moment';

interface KeyboardDate {
    date: Moment;
    formattedDate: string;
    isEmpty: boolean;
    isValid: boolean;
}

const dateFormat = 'D.M.YYYY';

/**
 * Simulates keyboard editing of a date string and returns the parsed result.
 *
 * @param previousDate - The current date input value.
 * @param key - The pressed key.
 * @param position - The caret position in the input.
 * @returns The parsed date state after applying the keyboard input.
 * @example
 * const result = insertedDateOnKeyboard('2.10.202', '2', 8);
 */
export const insertedDateOnKeyboard = (previousDate: string, key: string, position: number | null): KeyboardDate => {
    const isBackspace = key === 'Backspace';
    const positionIndex = position !== null ? position : 0;
    const insertedDate = !isBackspace
        ? insertElemsAt(positionIndex)(previousDate)(key)
        : removeAt(positionIndex - 1)(previousDate);
    const insertedDateWithNoSpaces = insertedDate.replace(/ /g, '');
    const momentWholeDate = moment(insertedDateWithNoSpaces, dateFormat, true);
    const formattedDate = momentWholeDate.format(beDateFormat);
    const isEmpty = insertedDate.length === 0;

    return {
        date: momentWholeDate,
        formattedDate,
        isEmpty,
        isValid: momentWholeDate.isValid(),
    };
};
